import { ScoreTypes } from '@/enums/score-types';
import { IDisplayScore } from '@/interfaces/display-score.interface';
import { store } from '@/store/store';
import { computed, Ref } from 'vue';

export default class Score {
	protected scoreTypes = ScoreTypes;

	protected displayScore = computed((): IDisplayScore | null => {
		return (
			store.getters
				.getActiveStudyStore()
				?.getters.displayScore(this.score.value) ?? null
		);
	});

	protected isBelow50 = computed((): boolean => {
		return this.displayScore.value?.label !== '';
	});

	constructor(
		protected score: Ref<number>,
		protected label?: string,
	) {}
}
